import React, { useState, useEffect } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Box,
} from '@mui/material';

function CategoryDialog({ open, onClose, onSave, category, categories }) {
  const [name, setName] = useState('');
  const [description, setDescription] = useState('');
  const [parentCategory, setParentCategory] = useState('');
  const [nameError, setNameError] = useState('');
  
  // Reset form when dialog opens or category changes
  useEffect(() => {
    if (open) {
      if (category) {
        setName(category.name || '');
        setDescription(category.description || '');
        setParentCategory(category.parentCategory || '');
      } else {
        setName('');
        setDescription('');
        setParentCategory('');
      }
      setNameError('');
    }
  }, [open, category]);
  
  const handleSubmit = (e) => {
    e.preventDefault();
    
    // Validate form
    if (!name.trim()) {
      setNameError('Category name is required');
      return;
    }
    
    // Prevent circular references
    if (category && parentCategory === category._id) {
      setNameError('A category cannot be its own parent');
      return;
    }
    
    onSave({
      name,
      description,
      parentCategory: parentCategory || null
    });
  };
  
  return (
    <Dialog 
      open={open} 
      onClose={onClose}
      maxWidth="sm"
      fullWidth
    >
      <DialogTitle>
        {category ? 'Edit Category' : 'Create New Category'}
      </DialogTitle>
      
      <form onSubmit={handleSubmit}>
        <DialogContent>
          <TextField
            autoFocus
            margin="dense"
            label="Category Name"
            fullWidth
            value={name}
            onChange={(e) => {
              setName(e.target.value);
              setNameError('');
            }}
            error={!!nameError}
            helperText={nameError}
            required
          />
          
          <TextField
            margin="dense"
            label="Description"
            fullWidth
            multiline
            rows={3}
            value={description}
            onChange={(e) => setDescription(e.target.value)}
          />
          
          <FormControl fullWidth margin="dense">
            <InputLabel>Parent Category (Optional)</InputLabel>
            <Select
              value={parentCategory}
              onChange={(e) => setParentCategory(e.target.value)}
              label="Parent Category (Optional)"
            >
              <MenuItem value="">
                <em>None (Top Level)</em>
              </MenuItem>
              
              {categories
                .filter(cat => !category || cat._id !== category._id)
                .map(cat => (
                  <MenuItem key={cat._id} value={cat._id}>
                    {cat.name}
                  </MenuItem>
                ))
              }
            </Select>
          </FormControl>
        </DialogContent>
        
        <DialogActions>
          <Button onClick={onClose}>Cancel</Button>
          <Button type="submit" variant="contained" color="primary">
            {category ? 'Update' : 'Create'}
          </Button>
        </DialogActions>
      </form>
    </Dialog>
  );
}

export default CategoryDialog; 